import React from "react";
import './App.css';

import LiberalLaw from "./static/LiberalLaw.png";
import FascistLaw from "./static/FascistLaw.png";

class VetoModal extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="center modal">
        <div className="headerText" style={{ color: 'black', fontSize: 60, textAlign: 'center' }} dangerouslySetInnerHTML={{ __html: this.props.prompt }} />
        <div style={{ flexDirection: 'row', display: 'flex' }}>
          { this.props.laws.map((law, index) => {
              var src;
              if (law === "LIBERAL") src = LiberalLaw;
              if (law === "FASCIST") src = FascistLaw;
              return(
                <img key={`item_${index}`} src={src} style={{ objectFit: 'contain', height: 200, borderRadius: 3, margin:20 }} />
              );
          })}
        </div>
        <div style={{ flexDirection: 'row', display: 'flex' }}>
          <div 
            onClick={() => { this.props.veto(true); }}
            className="center headerText clickable" 
            style={{ color: 'black', fontSize: 40, margin: 20, textAlign: 'center' }}
          >
            YES
          </div>
          <div 
            onClick={() => { this.props.veto(false); }}
            className="center headerText clickable" 
            style={{ color: 'black', fontSize: 40, margin: 20, textAlign: 'center' }}
          >
             NO
          </div>
        </div>
      </div>
    );
  }
}

export default VetoModal;
